/* eslint-disable no-loop-func */

export function CheckAbsent(data, teamMembers) {
  const userData = data.map((el) => (el?.success ? el.data : null));
  const dataToSend = [];
  const absentMembers = [];

  userData.forEach((element, i) => {
    if (element === null) {
      dataToSend.push('-');
      absentMembers.push('-');
    } else {
      const absent = teamMembers.filter(
        (m) => !element[m.userUID] || element[m.userUID].present !== true
      );
      absentMembers[i] = absent;
      dataToSend.push(absent.length);
    }
  });

  return {
    dataToShow: dataToSend,
    absentMembers,
  };
}
